import type { OfferDetailResult } from 'tripPlanner/api/types'
import type { DrawerHotel } from './types'
import { mapImages } from './mapToDrawerHotel'

export function mapOfferDetailToDrawerHotel(detail: OfferDetailResult): DrawerHotel {
  return {
    id: detail.offerId,
    offerId: detail.offerId,
    offerType: detail.offerType,
    slug: detail.slug,
    name: detail.name,
    description: detail.description,
    location: detail.location,
    images: mapImages(detail.images),
    rating: detail.rating,
    reviewsTotal: detail.reviewsTotal,
    inclusions: detail.inclusions?.map((inc, index) => ({
      id: `${detail.offerId}-inc-${index}`,
      description: inc.text,
      symbol: (inc.icon ?? undefined) as App.OfferFeatureSymbol | undefined,
      isHighlighted: inc.isHighlighted,
    })) ?? [],
    amenities: detail.amenities?.map((a) => ({
      name: a.name,
      icon: a.icon,
    })),
    price: detail.price !== undefined ? {
      total: detail.price,
      nights: detail.duration ?? 1,
      currency: detail.currencyCode,
    } : undefined,
    value: detail.value,
    discountPercent: detail.discountPercent,
    geoLocation: detail.geoLocation,
    deeplinkUrl: detail.deeplinkUrl,
    saleUnit: detail.saleUnit,
  }
}
